import React, { useEffect, useCallback } from 'react';
import styled from 'styled-components';

import { DEPRECATED, blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { labelExtraSmall } from '@zocdoc-mezzanine/foundations-typography';
import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { getSearchUrl } from '../../utils/getSearchUrl';

export const InNetworkOnlyWarning = ({
    inNetworkOnlyBookableText,
    procedureId,
    specialtyId,
    insuranceCarrierId,
    insurancePlanId,
    sendMetric,
    whiteLabelVanityUrl,
}) => {
    useEffect(() => {
        if (sendMetric) {
            sendMetric({
                initiator: EVENT_INITIATORS.USER,
                interactionType: INTERACTION_TYPES.VIEW,
                element: 'not in-network booking failure message',
                component: 'booking failure message',
                action: 'not in-network booking failure message',
                eventDetails: { insuranceCarrierId, insurancePlanId },
            });
        }
    }, [sendMetric, insuranceCarrierId, insurancePlanId]);

    const searchUrl = getSearchUrl(
        procedureId,
        specialtyId,
        insuranceCarrierId,
        insurancePlanId,
        whiteLabelVanityUrl
    );

    const onClickFindOtherProviders = useCallback(() => {
        sendMetric({
            action: 'find other providers CTA clicked',
            component: 'booking failure message',
            element: 'find other providers CTA',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
            section: 'booking failure message',
            eventDetails: {
                insuranceCarrierId,
                insurancePlanId,
                procedureId,
                specialtyId,
            },
        });
    }, [
        insuranceCarrierId,
        insurancePlanId,
        procedureId,
        sendMetric,
        specialtyId,
    ]);

    return (
        <InNetworkOnlyWarningWrapper
            data-test="in-network-only-warning-message"
            aria-live="polite"
        >
            {inNetworkOnlyBookableText}{' '}
            <FindOtherProvidersLink
                data-test="find-other-providers-link"
                href={searchUrl}
                onClick={onClickFindOtherProviders}
            >
                Find other providers
            </FindOtherProvidersLink>
        </InNetworkOnlyWarningWrapper>
    );
};

const InNetworkOnlyWarningWrapper = styled.div`
    color: ${DEPRECATED.feedbackWarning};
    font: ${labelExtraSmall};
    padding-top: 5px;
    padding-bottom: 20px;

    ${breakpoint.small} {
        padding-bottom: 5px;
    }
`;

const FindOtherProvidersLink = styled.a`
    color: ${blue100};
    text-decoration: underline;
`;
